import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Dialog, Button, AnchorButton, Intent } from '@blueprintjs/core'
import { delay } from 'core-js'

import { errorDialogModel } from '@client/components/ErrorDialog/model'
import { APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN } from '@config/app.config'
import { captureException } from '@client/utils/sentry'
import { tick } from '@client/utils/tick'

import './styles.scss'

@observer
class ErrorDialog extends Component {
  state = {
    isLoading: false,
  }

  static propTypes = {
    app: PropTypes.object,
    editor: PropTypes.object,
  }

  handleReconnect = async () => {
    this.setState({ isLoading: true })
    try {
      await tick(1000)
      const shownBefore = errorDialogModel.shownCount
      if (errorDialogModel.error.retry) {
        await errorDialogModel.error.retry()
      } else {
        await this.props.editor.save(true)
      }
      // A retry that failed the same way has raised the dialog again; closing
      // it now would leave the user thinking the save went through.
      if (errorDialogModel.shownCount === shownBefore) {
        errorDialogModel.hideError()
      }
    } catch (e) {
      captureException(e)
      console.error(e)
    }
    this.setState({ isLoading: false })
  }

  render() {
    const { formatMessage } = this.props.app
    return (
      <If condition={errorDialogModel.error.show}>
        <Dialog
          className="error-dialog"
          icon="error"
          title={formatMessage(
            errorDialogModel.error.retry
              ? 'common.loadComponent'
              : 'common.saveItemError'
          )}
          isOpen={errorDialogModel.error.show}
          canOutsideClickClose={false}
          canEscapeKeyClose={false}
          isCloseButtonShown={false}
          onClose={() => {
            errorDialogModel.hideError()
          }}
        >
          <div className="bp6-dialog-body">
            {formatMessage(
              errorDialogModel.error.retry
                ? 'common.loadComponent.description'
                : 'common.saveItemError.description'
            )}
          </div>
          <div className="bp6-dialog-footer">
            <div className="bp6-dialog-footer-actions">
              <AnchorButton href={`${APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN}`}>
                {formatMessage('common.returnToDashboard')}
              </AnchorButton>
              <div className="error-dialog__actions-right">
                <AnchorButton
                  href={`${APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN}/contact/`}
                  target="_blank"
                >
                  {formatMessage('common.getInTouch')}
                </AnchorButton>
                <Button
                  intent={Intent.PRIMARY}
                  onClick={this.handleReconnect}
                  loading={this.state.isLoading}
                  icon="refresh"
                >
                  {formatMessage('common.reconnect')}
                </Button>
              </div>
            </div>
          </div>
        </Dialog>
      </If>
    )
  }
}

export default ErrorDialog
